import { HOURS_MAP_24 } from '@/services/hours-map';

import { getSearchFilters } from '../../../../../../modules/search-filters-storage';
import { fillVariables } from '../../../../services/templates';

const getters = {
  cta(state, _getters) {
    let firstStep = 'Enquire now';

    if (state.roomSetupAllowsOP && !_getters.isWedding) {
      firstStep = 'Request to book';

      if (state.requestToBookPath) {
        return {
          firstStep,
          secondStep: 'Request to book',
          thirdStep: 'Review request',
          submitWithGoogle: 'Continue with Google',
          loginWithGoogle: 'Log in with Google',
          submitWithApple: 'Continue with Apple',
          loginWithApple: 'Log in with Apple',
        };
      }
      return {
        firstStep,
        secondStep: 'Finish your enquiry',
        thirdStep: state.user.isLoggedIn ? 'Send message' : 'Continue',
        submitWithGoogle: 'Continue with Google',
        loginWithGoogle: 'Log in with Google',
        submitWithApple: 'Continue with Apple',
        loginWithApple: 'Log in with Apple',
      };
    }

    return {
      firstStep,
      secondStep: 'Finish your enquiry',
      thirdStep: 'Send message',
      submitWithGoogle: 'Send with Google',
      submitWithApple: 'Send with Apple',
    };
  },
  enquiryFormVariant(state, _getters) {
    if (state.user.lastEnquiry.date) {
      return 'already_enquired';
    }

    if (state.isVenueSuspended) {
      return 'venue_suspended';
    }

    if (_getters.isWedding) {
      return 'request_brochure';
    }

    if (state.roomSetupAllowsOP) {
      return 'request_to_book';
    }

    return 'enquire_now';
  },
  roomPagesContextForTracking(state) {
    if (state.roomSetupAllowsOP) {
      if (state.requestToBookPath) {
        return 'request_to_book';
      }

      return 'message_host';
    }

    return 'enquire_now';
  },
  isWedding(state) {
    const WEDDING_ROOM_TAGS = [
      'asian-weddings',
      'dry-hire-wedding',
      'garden-wedding',
      'gay-wedding',
      'marquee-wedding',
      'outdoor-wedding',
      'unique-wedding',
      'unusual-wedding',
      'wedding',
      'wedding-reception',
      'wedding-ceremonies',
      'micro-wedding',
      'rooftop-wedding',
    ];

    const isMobile = window.matchMedia('(max-width: 767.98px)').matches;
    return WEDDING_ROOM_TAGS.includes(state.user.searchedEventType) && isMobile;
  },

  isRtbFlowPossible(state, _getters) {
    return state.roomSetupAllowsOP && !_getters.isWedding;
  },
  isLayoutAndExtendedCateringFlow(state, _getters) {
    if (_getters.isRtbFlowPossible || _getters.isWedding) {
      return false;
    }

    const json = getSearchFilters();
    if (!json) {
      return false;
    }

    const allowedEventCategories = [
      'party',
      'business',
      'venue_type',
    ];
    return allowedEventCategories.includes(json.eventCategory);
  },

  eventTypeSpecificCopy(state, _getters) {
    if (_getters.isWedding) {
      return {
        people: 'Estimated number of guests',
        eventDate: 'Wedding date',
        startEnquiry: 'Request a free brochure',
      };
    }
    return {
      people: 'People',
      eventDate: 'Date and time',
      startEnquiry: 'Enquire now',
    };
  },

  searchSimilarEventsUrl(state) {
    const form = state.form.dateAndPeople;

    return fillVariables(state.pages.enquirySearchPageUrl, {
      roomTag: form.eventType || 'event-venue',
      people: form.people || '',
      date: form.date || '',
      timeFrom: form.timeFrom || '',
      timeTo: form.timeTo || '',
    });
  },

  ga4ParamsBase(state, _getters) {
    // return function to reevaluate login state on each call
    return () => {
      const date = state.form.dateAndPeople.date
        ? window.dayjs(state.form.dateAndPeople.date, 'DD/MM/YYYY')
        : null;

      return {
        enquiry_form_variant: _getters.enquiryFormVariant,
        event_date: date?.format('YYYY-MM-DD') || null,
        event_tag_slug: state.form.dateAndPeople.eventType,
        hour_from: HOURS_MAP_24[state.form.dateAndPeople.timeFrom],
        hour_to: HOURS_MAP_24[state.form.dateAndPeople.timeTo],
        number_of_people: state.form.dateAndPeople.people ? +state.form.dateAndPeople.people : null,
      };
    };
  },
  authEventsTrackingParams: (state, _getters) => (authMethod) => {
    return {
      context: _getters.roomPagesContextForTracking,
      auth_method: authMethod,
      country: state.l10n.ISOCountryCode,
    };
  },
  getTM5484ExperimentCtaCopy(state) {
    const version = state.experimentTM5484Version || 0;
    const country = state.l10n.ISOCountryCode;

    let config = {
      0: 'Enquire now',
      1: 'Request a quote',
      2: 'Request availability',
    };

    if (['US', 'CA'].includes(country)) {
      config = {
        0: 'Enquire now',
        1: 'Inquire now',
        2: 'Request a quote',
      };
    }

    return config[version];
  },
};

export default getters;
